import { createSelector } from 'reselect';

import { OrderingSelectors, OrderingConstants } from 'polygon-ordering';

import getCurrentSavedCardTokenExists from './getCurrentSavedCardTokenExists';
// import getSelectedPaymentMethods from './getSelectedPaymentMethods';
import type { RootState } from 'store';

const { getSelectedPaymentMethods } = OrderingSelectors;
const { PAYMENT_METHOD } = OrderingConstants;

const getCurrentSavedCardToken = (state: RootState) => state.currentSavedCardToken;

export default createSelector(
  [getCurrentSavedCardToken, getSelectedPaymentMethods, getCurrentSavedCardTokenExists],
  (currentSavedCardToken, selectedPaymentMethods, currentSavedCardTokenExists) => {
    let selectedPaymentMethodsIncludesSavedCard = selectedPaymentMethods.some(
      (object: { method: OrderingConstants.PAYMENT_METHOD }) => {
        if (object.method === PAYMENT_METHOD.SAVED_CARD) {
          return true;
        }
        return false;
      },
    );

    if (!selectedPaymentMethodsIncludesSavedCard) {
      return undefined;
    }

    if (!currentSavedCardTokenExists) {
      return undefined;
    }

    return currentSavedCardToken;
  },
);
